// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__3fZoD","header":"ReportDetails_header__kXZiH","title":"ReportDetails_title__3AMZ-","left":"ReportDetails_left__1TQ4j"};